module.exports = __webpack_public_path__ + "img/czapki-zimowe.32676c24.jpeg";